import { Component, computed, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { BUSNQuoteScheduleService, BUSNThirdPartyService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import {
  HeadersType,
  IBank,
  IBankBranch,
  IBankingDetails,
  IPremiaBankingDetails,
  IPremiaLOV,
  SharedConfig,
  SharedDialogService,
  SharedFormulaService,
} from '@takectrl-multiapp/svcs-share-config';
declare const dataLayer: any[];

@Component({
  selector: 'quote-banking-details',
  standalone: false,
  templateUrl: './quote-banking-details.component.html',
  styleUrls: ['./quote-banking-details.component.scss'],
})
export class QuoteBankingDetailsComponent implements OnInit {
  @Output() navigateCasaOrComplete: EventEmitter<unknown> = new EventEmitter<unknown>();
  banksAll: IBank[] = [];
  banksFiltered: IBank[] = [];
  banksPopular: IBank[] = [];
  bank_branches: Array<IBankBranch> = [];
  branchListSortName = [];
  branchListSortCode = [];
  collectionDates = [];
  banking_details = {} as IBankingDetails;
  newEmail: string;
  cover_start_date: string;
  bankSearchText: string;
  showPopular = true;
  maxDate: any;
  minDate = this.sharedFormulaService.formatDateyyymmdd(Date.now());
  showUpdateEmailPopup = false;
  bankSelectPopup = false;
  showDeductionDay = false;
  collection_day: string;
  branchAndCode: string;
  showEmailChangePopup = false;
  passwordField: string;
  // Returned Values
  insurer_id = SharedConfig.selectedQuote.insurer_id;

  // PREMIA
  insurerProviderIsPremia = signal(false);
  premiaBankingDetails = {} as IPremiaBankingDetails;
  premiaBanks = signal<IPremiaLOV[]>([]);
  premiaBankSearchText = signal('');
  premiaBanksFiltered = computed(() =>
    this.premiaBanks().filter((bank) => bank.description.toLowerCase().includes(this.premiaBankSearchText().toLowerCase()))
  );
  premiaAccountTypes = signal<IPremiaLOV[]>([]);
  premiaRelationshipTypes = signal<IPremiaLOV[]>([]);
  premiaBankPopup = signal(false);
  premiaAccountTypePopup = signal(false);
  premiaRelationshipTypePopup = signal(false);

  constructor(
    private readonly busnQuoteScheduleService: BUSNQuoteScheduleService,
    private readonly alertCtrl: AlertController,
    public userService: BUSNUserService,
    private readonly busnThirdPartyService: BUSNThirdPartyService,
    public sharedConfig: SharedConfig,
    private readonly sharedFormulaService: SharedFormulaService,
    private readonly loadCtrl: LoadingController,
    private readonly sharedDialogService: SharedDialogService
  ) {}

  ngOnInit(): void {
    const dateMax = this.sharedFormulaService.addDays(new Date(this.sharedConfig.quoteRequest.effective_date), 59);
    this.maxDate = this.sharedFormulaService.formatDateyyymmdd(dateMax);

    this.insurerProviderIsPremia.set(SharedConfig?.insurers()?.find((x) => x.insurer_id === this.insurer_id)?.provider === 'premia');
    if (this.insurerProviderIsPremia()) {
      this.premiaBankingDetails.account_holder = `${this.sharedConfig.user.personal_details?.name} ${this.sharedConfig.user.personal_details?.surname}`;
    } else {
      this.banking_details.account_holder = `${this.sharedConfig.user.personal_details?.name} ${this.sharedConfig.user.personal_details?.surname}`;
    }

    this.collectionDates = this.sharedFormulaService.getDateOrdinalsForMonth();

    dataLayer.push({
      event: 'page_show',
      screenPath: 'quote-banking-details',
      screenName: 'quote-banking-details',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
  }

  accountHolderValueChange(e: Event) {
    this.banking_details.account_holder = e.target['value'];
  }

  accountNumberValueChange(e: Event) {
    this.banking_details.account_number = e.target['value'];
  }

  bankSearchValueChange(searchText: string) {
    this.bankSearchText = searchText;

    if (!this.bankSearchText || this.bankSearchText.length <= 0) {
      this.showPopular = true;
    } else {
      this.showPopular = false;

      this.banksFiltered = this.banksAll.slice();
      this.banksFiltered = this.banksFiltered.filter((x) => x.bankName.toLocaleLowerCase().includes(this.bankSearchText.toLocaleLowerCase()));
    }
  }

  openCalendar() {
    SharedConfig.showCalendarPopup = true;
  }

  onBankBranchNameSelected(name: string) {
    const branch = this.bank_branches.find((b) => b.name === name);
    if (branch) this.banking_details.branch_code = branch.code;
  }

  onBankBranchCodeSelected(code: string) {
    const branch = this.bank_branches.find((b) => b.code === code);
    if (branch) this.banking_details.branch_name = branch.name;
  }

  onCollectionDaySelected(collection_day) {
    this.showDeductionDay = false;
    this.collection_day = collection_day.day_ordinal_display_name;
    this.banking_details.collection_day = collection_day.day;
    SharedConfig.showFullScreen = false;
  }

  canContinue() {
    if (this.insurerProviderIsPremia()) {
      return (
        !!this.premiaBankingDetails.account_holder &&
        !!this.premiaBankingDetails.account_number &&
        !!this.premiaBankingDetails.bank_code &&
        !!this.premiaBankingDetails.branch_code &&
        !!this.premiaBankingDetails.account_type_code &&
        !!this.premiaBankingDetails.account_relationship_code
      );
    }

    if (this.insurer_id === 'KINGPRICE') {
      return !!this.cover_start_date;
    }

    return (
      !!this.banking_details.account_number &&
      !!this.banking_details.financial_institution &&
      !!this.banking_details.branch_code &&
      !!this.banking_details.branch_name &&
      !!this.banking_details.collection_day &&
      !!this.cover_start_date
    );
  }

  continue() {
    this.busnThirdPartyService.logEvent('action_quote_banking_details_completed', {
      timestamp: new Date(),
      quote_request_id: this.sharedConfig.quoteRequest.id,
    });
    if (this.insurerProviderIsPremia()) {
      // delete this.premiaBankingDetails.bank_description;
      // delete this.premiaBankingDetails.branch_description;
      // delete this.premiaBankingDetails.account_type_description;
      // delete this.premiaBankingDetails.account_relationship_description;
      this.premiaBankingDetails.quotes_id = SharedConfig.selectedQuote.id!;
      SharedConfig.premiaQuoteBankingDetails = this.premiaBankingDetails;
    } else if (this.insurer_id !== 'KINGPRICE') {
      SharedConfig.quoteBankingDetails = this.banking_details;
    }
    this.navigateCasaOrComplete.emit();
  }

  openUpdateEmailPopup() {
    this.showUpdateEmailPopup = true;
    SharedConfig.showHeaderForType = HeadersType.updateEmail;
    this.newEmail = '';
  }

  closeComponentPopup() {
    switch (SharedConfig.showHeaderForType) {
      case HeadersType.updateEmail:
        this.showUpdateEmailPopup = false;
        break;
      case HeadersType.bank:
        this.bankSelectPopup = false;
        this.banksFiltered = this.banksAll;
        this.premiaBankPopup.set(false);
        break;
      case HeadersType.accountType:
        this.premiaAccountTypePopup.set(false);
        break;
      case HeadersType.relationshipType:
        this.premiaRelationshipTypePopup.set(false);
        break;
    }
    delete SharedConfig.showHeaderForType;
  }

  async openBankSelectPopup() {
    SharedConfig.showHeaderForType = HeadersType.bank;
    this.bankSelectPopup = true;
    this.sharedConfig.setShowCustomLoader(true);
    this.busnQuoteScheduleService.getBanks().then(async (banks) => {
      this.banksAll = banks as Array<IBank>;
      this.banksFiltered = banks as Array<IBank>;
      this.banksPopular = (banks as Array<IBank>).filter(
        (x) =>
          x.display === 'ABSA' ||
          x.display === 'Capitec' ||
          x.display === 'FNB' ||
          x.display === 'Investec' ||
          x.display === 'Nedbank' ||
          x.display === 'Standard Bank'
      );
      this.sharedConfig.setShowCustomLoader(false);
    });
  }

  async updateEmail() {
    if (this.newEmail && this.newEmail !== '') {
      this.showEmailChangePopup = true;
      SharedConfig.showFullScreen = true;
    }
  }

  async confirmEmailChange() {
    this.sharedConfig.setShowCustomLoader(true);
    try {
      let changeMailRes = await this.userService.changeEmailAddress(this.newEmail);
      this.dismissCustomPopup();
      if (changeMailRes.success) {
        this.sharedConfig.setShowCustomLoader(false);
        this.sharedConfig.user.personal_details.email = this.newEmail;
        this.sharedDialogService.showPopupDialog({
          header: 'Updated',
          subHeader: 'Your email has been change to ' + this.newEmail,
          buttonOneText: 'Ok',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
      } else {
        this.sharedConfig.setShowCustomLoader(false);
        this.sharedDialogService.showPopupDialog({
          header: 'Something went wrong',
          subHeader: 'Please try again later',
          buttonOneText: 'Close',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
      }
    } catch (error) {
      this.dismissCustomPopup();
      this.sharedConfig.setShowCustomLoader(false);
      this.sharedDialogService.showPopupDialog({
        header: 'Something went wrong',
        subHeader: 'Please try again later',
        buttonOneText: 'Close',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    }
  }

  dismissCustomPopup() {
    this.showEmailChangePopup = false;
    SharedConfig.showFullScreen = false;
  }

  cancelPopupEmail() {
    this.showUpdateEmailPopup = false;
    delete SharedConfig.showHeaderForType;
  }

  selectBank(bank: IBank) {
    this.bankSelectPopup = false;
    delete SharedConfig.showHeaderForType;
    this.banking_details.financial_institution = bank.bankName;
    this.banking_details.branch_code = bank.miwayBranchCode;
    this.banking_details.branch_name = bank.miwayBranchName;
    this.branchAndCode = `${bank.miwayBranchName}, ${bank.miwayBranchCode}`;
    this.banksAll = [];
    this.banksFiltered = [];
    this.banksPopular = [];
  }

  async setCoverStartDate(dateValue) {
    const dateDialogAnswer = dateValue.split('T')[0];
    this.cover_start_date = dateDialogAnswer;
    this.sharedConfig.quoteRequest.cover_start_date = dateDialogAnswer;
    this.busnQuoteScheduleService.updateCoverStartDate(dateDialogAnswer, this.sharedConfig.quoteRequest);
  }

  async openDeductionDay() {
    SharedConfig.showFullScreen = true;
    this.sharedConfig.setShowCustomLoader(true);
    const intervalId = setInterval(() => {
      this.sharedConfig.setShowCustomLoader(false);
      this.showDeductionDay = true;
      clearInterval(intervalId);
    }, 100);
  }

  // PREMIA INTEGRATION

  async openPremiaBankPopup() {
    SharedConfig.showHeaderForType = HeadersType.bank;
    this.premiaBankPopup.set(true);
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnQuoteScheduleService.getPremiaBanks().then((banks) => {
      this.premiaBanks.set(banks);
      this.sharedConfig.setShowCustomLoader(false);
    });
  }

  async selectPremiaBank(bank: IPremiaLOV) {
    delete SharedConfig.showHeaderForType;
    this.sharedConfig.setShowCustomLoader(true);
    this.premiaBankSearchText.set('');
    await this.busnQuoteScheduleService.getPremiaBranches(bank.code).then((branches) => {
      this.premiaBankingDetails.bank_code = bank.code;
      this.premiaBankingDetails.bank_description = bank.description;
      this.premiaBankingDetails.branch_code = branches[0].code;
      this.premiaBankingDetails.branch_description = branches[0].description;
      this.sharedConfig.setShowCustomLoader(false);
      this.premiaBankPopup.set(false);
    });
  }

  async openPremiaAccountTypePopup() {
    SharedConfig.showHeaderForType = HeadersType.accountType;
    this.premiaAccountTypePopup.set(true);
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnQuoteScheduleService.getPremiaAccountTypes().then((accountTypes) => {
      this.premiaAccountTypes.set(accountTypes);
      this.sharedConfig.setShowCustomLoader(false);
    });
  }

  selectPremiaAccountType(accountType: IPremiaLOV) {
    delete SharedConfig.showHeaderForType;
    this.premiaBankingDetails.account_type_code = accountType.code;
    this.premiaBankingDetails.account_type_description = accountType.description;
    this.premiaAccountTypePopup.set(false);
  }

  async openPremiaRelationshipTypePopup() {
    SharedConfig.showHeaderForType = HeadersType.relationshipType;
    this.premiaRelationshipTypePopup.set(true);
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnQuoteScheduleService.getPremiaRelationshipTypes().then((relationshipTypes) => {
      this.premiaRelationshipTypes.set(relationshipTypes);
      this.sharedConfig.setShowCustomLoader(false);
    });
  }

  selectPremiaRelationshipType(relationshipType: IPremiaLOV) {
    delete SharedConfig.showHeaderForType;
    this.premiaBankingDetails.account_relationship_code = relationshipType.code;
    this.premiaBankingDetails.account_relationship_description = relationshipType.description;
    this.premiaRelationshipTypePopup.set(false);
  }
}
